import { render, staticRenderFns } from "./SampleDX.vue?vue&type=template&id=c22ad8b8&scoped=true"
import script from "./SampleDX.vue?vue&type=script&lang=js"
export * from "./SampleDX.vue?vue&type=script&lang=js"
import style0 from "./SampleDX.vue?vue&type=style&index=0&id=c22ad8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22ad8b8",
  null
  
)

export default component.exports